import { createContext, useCallback, useState } from 'react'
import Toast from '~components/Toast'
import { SeverityType } from './interfaces'

const ToastContext = createContext({} as (severity: SeverityType, heading: string, duration?: number) => void)

export default ToastContext

const DEFAULT_TIMELAPSE = 6000

export function ToastProvider({ children }) {
  const [duration, setDuration] = useState<number | null>(null)
  const [isOpen, setOpen] = useState(false)
  const [severity, setSeverity] = useState<SeverityType>('neutral')
  const [heading, setHeading] = useState('')

  const openToast = useCallback(function (severity: SeverityType, heading: string, duration?: number) {
    setSeverity(severity)
    setHeading(heading)
    setOpen(true)
    setDuration(duration ?? DEFAULT_TIMELAPSE)
  }, [])

  function handleClose() {
    setOpen(false)
  }

  return (
    <ToastContext.Provider value={openToast}>
      <Toast severity={severity} heading={heading} isOpen={isOpen} onClose={handleClose} duration={duration} />
      {children}
    </ToastContext.Provider>
  )
}
